import { render, staticRenderFns } from "./NewReserva.vue?vue&type=template&id=79965e44&scoped=true"
import script from "./NewReserva.vue?vue&type=script&lang=js"
export * from "./NewReserva.vue?vue&type=script&lang=js"
import style0 from "./NewReserva.vue?vue&type=style&index=0&id=79965e44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79965e44",
  null
  
)

export default component.exports